import { TextField, InputAdornment } from "@mui/material";
import { MapPinIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";

interface ZipCodeFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  validate?: boolean;
  showError?: boolean;
}

const ZipCodeField: React.FC<ZipCodeFieldProps> = ({
  label,
  name,
  value,
  onChange,
  required = false,
  validate = true,
  showError = true,
}) => {
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 6); // Limit to 6 digits
    const customEvent = {
      target: {
        name,
        value: digitsOnly,
      },
    } as React.ChangeEvent<HTMLInputElement>;
    onChange(customEvent);
  };

  useEffect(() => {
    if (!validate) return;

    if (!value || value.trim().length === 0) {
      setError(required);
      setHelperText(required ? "Zip code is required" : "");
    } else if (!/^\d{6}$/.test(value)) {
      setError(true);
      setHelperText("Zip code must be exactly 6 digits");
    } else {
      setError(false);
      setHelperText("");
    }
  }, [value, required, validate]);

  return (
    <TextField
      fullWidth
      required={required}
      name={name}
      label={label}
      type="text"
      value={value}
      onChange={handleInput}
      error={showError && error}
      helperText={showError && error ? helperText : ""}
      inputProps={{ maxLength: 6 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <MapPinIcon className="h-5 w-5 text-gray-500" />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default ZipCodeField;
